/**
 * Dev-only logger. Silenced in production builds so we don't leak internals
 * or noise the browser console for end users.
 */
const IS_DEV = process.env.NODE_ENV !== "production";

export function logWarn(...args) {
  if (IS_DEV) console.warn(...args);
}

export function logError(...args) {
  if (IS_DEV) console.error(...args);
}
